export default "/images/plus.svg?3244e1e6a0a4d5280a4e7e0f220e6e51";